/** One retry covers a transient failure while the agent is connecting. */
export const SETTINGS_LOAD_ATTEMPTS = 2;

/** Wait before retrying, so a short outage (a deploy switch, a database stall) has time to clear. */
export const SETTINGS_RETRY_DELAY_MILLISECONDS = 1000;
